import Controller, { inject as controller } from '@ember/controller';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { task } from 'ember-concurrency';
import { queryEncode } from 'cio/helpers/query';
import SegmentController from 'cio/pods/segments/segment/controller';
import DS from 'ember-data';
import FeaturesService from 'ember-feature-flags/services/features';
import RouterService from '@ember/routing/router-service';

export default class OverviewController extends Controller {
  @service store!: DS.Store;
  @service features!: FeaturesService;
  @service router!: RouterService;

  declare model: SegmentController['model'];

  @controller('segments.segment') segmentController!: SegmentController;

  @readOnly('fetchAudiences.last.value.length') audiencesCount!: number;

  get isEditing() {
    return this.router.currentRouteName === 'segments.segment.overview.edit';
  }

  fetchAudiences = task(async () => {
    return (await this.model.get('audiences')).content;
  });

  @computed('model.id')
  get segmentPeopleFilters() {
    return queryEncode({
      and: [
        {
          segment: { id: this.model.id },
        },
      ],
    });
  }
}

declare module '@ember/controller' {
  interface Registry {
    'segments.segment.overview': OverviewController;
  }
}
